/**
 * Analytics Events for Landing Training Sessions
 *
 * Track key user interactions and session lifecycle events
 * for monitoring and optimization.
 */

type SessionEventType =
  | "session_created"
  | "session_started"
  | "session_ended"
  | "session_error"
  | "feedback_viewed"
  | "media_permission_changed";

type SessionEventData = {
  sessionId: string;
  scenarioType?: string;
  duration?: number;
  errorMessage?: string;
  mediaType?: "audio" | "video";
  enabled?: boolean;
};

/**
 * Track session analytics event
 *
 * Currently logs to console. Replace with actual analytics service
 * (e.g., Mixpanel, Amplitude, Google Analytics) when ready.
 */
export function trackSessionEvent(
  event: SessionEventType,
  data: SessionEventData,
): void {
  if (process.env.NODE_ENV === "development") {
    console.log(`[Analytics] ${event}:`, data);
  }

  // TODO: Implement actual analytics tracking
  // Example:
  // analytics.track(event, data);
  // mixpanel.track(event, data);
}
